import script from "./clients-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./clients-grid.vue?vue&type=script&setup=true&lang=js"

import "./clients-grid.vue?vue&type=style&index=0&id=96e2fb24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96e2fb24"]])

export default __exports__